export enum FileSizes {
  MegaBytes,
  GigaBytes,
}
